<template>
    <div class="panel">
        <div class="panel-head">
            <div>
                <div class="panel-title">Top Experiences</div>
            </div>
        </div>

        <div v-if="!experiences.length" class="empty-state">No sales data yet</div>

        <div class="exp-row" v-for="(exp, index) in experiences" :key="exp.name">
            <div class="exp-rank" :class="{ first: index === 0 }">{{ index + 1 }}</div>

            <div class="exp-info">
                <div class="exp-name">{{ exp.name }}</div>
                <div class="exp-meta">{{ exp.bookings }} bookings</div>
            </div>

            <div class="exp-sales">{{ exp.sales }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        experiences: { type: Array, default: () => [] }
    }
}
</script>

<style lang="scss" scoped>
.panel {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1.25rem 1.4rem;
    height: 100%;
}

.panel-title {
    font-size: .95rem;
    font-weight: 700;
}

.panel-sub {
    font-size: .72rem;
    color: var(--ink-faint);
    margin-top: .15rem;
}

.panel-head {
    margin-bottom: .25rem;
}

.empty-state {
    font-size: .78rem;
    color: var(--ink-faint);
    padding: .75rem 0;
}

.exp-row {
    display: flex;
    align-items: center;
    gap: .65rem;
    padding: .6rem 0;
    border-bottom: 1px solid var(--line);

    &:last-child {
        border-bottom: none;
    }
}

.exp-rank {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: var(--paper);
    color: var(--ink-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'IBM Plex Mono', monospace;
    font-size: .7rem;
    font-weight: 600;
    flex-shrink: 0;

    &.first {
        background: var(--amber-soft);
        color: #a4700f;
    }
}

.exp-info {
    flex: 1;
    min-width: 0;
}

.exp-name {
    font-size: .82rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.exp-meta {
    font-size: .68rem;
    color: var(--ink-faint);
    margin-top: .1rem;
}

.exp-sales {
    font-family: 'IBM Plex Mono', monospace;
    font-size: .78rem;
    font-weight: 600;
    flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// topExperiences.vue?7863a8b1